import { operationStore } from "@urql/svelte";
import { CATEGORIES } from "./constants";
import "graphql-request";
import { graphQLClients } from "../utils/utils";
const defaultVariablesGetPairs = {
    orderBy: 'timestamp',
    orderDirection: 'desc',
    category: [...CATEGORIES, ""],
    offset: 0,
};
const defaultVariablesGetPairCount = {
    category: [...CATEGORIES, ""],
};
const getPairsQuery = `
    query ($orderBy: String!, $orderDirection: String!, $category: [String!]!, $offset: Int!){
      pairs(first: 9, skip: $offset, orderBy: $orderBy, orderDirection: $orderDirection, where: { activated: true, category_in: $category }) {
        id
        nftAddress
        tokenId
        title
        baseToken {
          id
          symbol
          decimals
        }
        nftPrice
        roundTokenPrice
        roundTokenTotalSupply
        category
        collection
        timestamp
        pairHourData(first: 25, orderBy: id, orderDirection: desc) {
          periodStart
          pairReward
          open
          close
          roundTokenTotalSupply
        }
      }
    }`;
const getCountQuery = `
  query ($category: [String!]!) {
    categoryCounts(where: {id_in: $category}) {
      id
      pairCount
    }
  }`;
export const getPairs = operationStore(getPairsQuery, defaultVariablesGetPairs);
export const getPairList = (chainId, variables) => {
    return graphQLClients[chainId].request(getPairsQuery, Object.assign({}, defaultVariablesGetPairs, variables));
};
export const getPairCount = (chainId, variables) => {
    return graphQLClients[chainId].request(getCountQuery, Object.assign({}, defaultVariablesGetPairCount, variables));
};
export const getCount = operationStore(`
  query ($category: [String!]!) {
    categoryCounts(where: {id_in: $category}) {
      id
      pairCount
    }
  }`, {
    category: [...CATEGORIES, ""],
});
export const getPairDetail = operationStore(`
  query ($metaNftId: String!) {
    pair(id: $metaNftId) {
      id
      nftAddress
      tokenId
      title
      baseToken {
        id
        symbol
        decimals
      }
      roundTokenPrice
      roundTokenTotalSupply
      category
      collection
      activated
      owner {
        id
      }
      pairHourData(first: 25, orderBy: id, orderDirection: desc) {
        periodStart
        pairReward
        open
        close
        roundTokenTotalSupply
      }
      descriptionHash
    }
  }`, {
    metaNftId: '',
});
export const getTotalRoundValue = operationStore(`
  query ($address: String!) {
    user(id: $address) {
      earnedReward
      claimedReward
      roundTokenBalances(where: {roundTokenBalance_gt: 0}) {
        roundTokenBalance
        pair {
          baseToken {
            id
            symbol
            decimals
          }
          roundTokenPrice
        }
        averageCost
      }
    }
  }`, {
    address: '',
});
const getRoundsQuery = `
  query ($address: String!, $limit: Int! $offset: Int!) {
    user(id: $address) {
      id
      roundTokenBalances(first: $limit, skip: $offset, orderBy: roundTokenBalance, orderDirection: desc, where: {roundTokenBalance_gt: 0}) {
        roundTokenBalance
        averageCost
        pair {
          id
          nftAddress
          tokenId
          baseToken {
            id
            symbol
            decimals
          }
          activated
          roundTokenPrice
          title
          pairHourData(first: 25, orderBy: id, orderDirection: desc) {
            periodStart
            pairReward
            open
            close
            roundTokenTotalSupply
          }
        }
      }
    }
  }`;
const defaultVariablesGetRounds = {
    address: '',
    limit: 5,
    offset: 0,
};
export const getRounds = operationStore(getRoundsQuery, defaultVariablesGetRounds);
export const getRoundList = (chainId, variables) => {
    return graphQLClients[chainId].request(getRoundsQuery, Object.assign({}, defaultVariablesGetRounds, variables));
};
export const getTotalMetaNftValue = operationStore(`
  query ($address: String) {
    user(id: $address) {
      id
      pairs(where: {activated: true}) {
        nftPrice
        earnedReward
        claimedReward
        baseToken {
          id
          symbol
          decimals
        }
        pairDayData(first: 1, orderBy: date, orderDirection: asc) {
          open
        }
      }
    }
  }`, {
    address: '',
});
const getMetaNFTsQuery = `
  query ($address: String!, $limit: Int! $offset: Int!) {
    user(id: $address) {
      id
      pairs(first: $limit, skip: $offset, orderBy: roundTokenPrice, orderDirection: desc) {
        id
        nftAddress
        tokenId
        baseToken {
          id
          symbol
          decimals
        }
        earnedReward
        claimedReward
        activated
        nftPrice
        title
        pairDayData(first: 1, orderBy: date, orderDirection: asc) {
          open
        }
        pairHourData(first: 25, orderBy: id, orderDirection: desc) {
          periodStart
          pairReward
          open
          close
          roundTokenTotalSupply
        }
      }
    }
  }`;
const defaultVariablesGetMetaNFTs = {
    address: '',
    limit: 5,
    offset: 0,
};
export const getMetaNfts = operationStore(getMetaNFTsQuery, defaultVariablesGetMetaNFTs);
export const getMetaNFTList = (chainId, variables) => {
    return graphQLClients[chainId].request(getMetaNFTsQuery, Object.assign({}, defaultVariablesGetMetaNFTs, variables));
};
const getBidsQuery = `
  query ($address: String!, $limit: Int! $offset: Int!) {
    user(id: $address) {
      bids(first: $limit, skip: $offset, orderBy: timestamp, orderDirection: desc) {
        id
        timestamp
        expiry
        amountIn
        status
        isNft
        sender {
          id
        }
        pair {
          id
          nftAddress
          tokenId
          baseToken {
            id
            symbol
            decimals
          }
          activated
          roundTokenPrice
          title
          roundTokenTotalSupply
        }
      }
    }
  }`;
const defaultVariablesGetBids = {
    address: '',
    limit: 10,
    offset: 0,
};
export const getBids = operationStore(getBidsQuery, defaultVariablesGetBids);
export const getBidList = (chainId, variables) => {
    return graphQLClients[chainId].request(getBidsQuery, Object.assign({}, defaultVariablesGetBids, variables));
};
export const getXPilRatio = operationStore(`
  query {
    stakingHourDatas(first: 25, orderBy: id, orderDirection: desc) {
      id
      openRatio
      closeRatio
    }
  }`);
